<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        Choose Membership Plan
      </h3>
    </div>
    <hr class="card-title-line">
    <div class="card-content">
      <p
        v-if="trialRenderConfig?.isEligible"
        class="notification-message mb-20 mt-10"
      >
        {{ trialRenderConfig.registration.text }}
      </p>
      <price-planning-table
        :is-operator-registration="true"
        @choose-membership="chooseMembership"
        @choose-annual-type="chooseAnnualType"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';
import { ElLoading } from 'element-plus';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { trialRenderConfig } from '@/services/abTests/abTestsViewModel';
import { callerService } from '@/services/caller';

const PricePlanningTable = defineAsyncComponent(() => import('@/components/UIComponents/PricePlanning.vue') as any);

const emit = defineEmits(['goto-next-step', 'valid']);

const { newCustomerInfo, setNewCustomerInfo } = useCustomer();

const { showSuccessPopupDialog, showErrorPopupDialog, showConfirmPopupDialog } = useSwalDialog();

const isAnnuallyType = ref(false);

const chooseMembership = async (plan: string, planName: string) => {
  const annualPlanConfirmHtml = `
    <ul class="text-left">
      <li class="mb-3">Please confirm that this is the plan the user wants!</li>
    </ul>
  `;
  const monthlyPlanConfirmHtml = 'Please confirm that this is the plan the user wants!';

  const isPlanConfirmed = await showConfirmPopupDialog({
    text: isAnnuallyType.value ? annualPlanConfirmHtml : monthlyPlanConfirmHtml,
    title: planName,
    type: 'html',
  });

  if (!isPlanConfirmed) {
    return;
  }

  const loading = ElLoading.service({
    lock: true,
    text: 'Updating membership plan...',
    background: 'rgba(0, 0, 0, 0.7)',
    customClass: 'custom-full-spinner-class',
  });

  try {
    await callerService.updateCaller({
      callerId: newCustomerInfo.value.id,
      data: {
        registerPlan: plan,
      },
    });

    loading.close();
    await showSuccessPopupDialog({
      text: 'The membership has been updated successfully.',
    });
    emit('valid', true);

    setNewCustomerInfo({
      ...newCustomerInfo.value,
      registerPlan: plan,
    });

    emit('goto-next-step');
  } catch (error) {
    loading.close();

    const errorText = util.getErrorResponse(error, false);
    showErrorPopupDialog({
      text: errorText,
    });
    emit('valid', false);
  }
};

const chooseAnnualType = (value: boolean) => {
  isAnnuallyType.value = value;
};
</script>
